import { render, staticRenderFns } from "./AdvisoryMan.vue?vue&type=template&id=00b57bce&scoped=true"
import script from "./AdvisoryMan.vue?vue&type=script&lang=js"
export * from "./AdvisoryMan.vue?vue&type=script&lang=js"
import style0 from "./AdvisoryMan.vue?vue&type=style&index=0&id=00b57bce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b57bce",
  null
  
)

export default component.exports